import classNames from 'classnames';
import React from 'react';
import styles from './alert.module.scss'

export type AlertTypes =
  'breaking-news'     |
  'developing-story'  |
  'rightNow'          |
  'error'             |
  'disclaimer'        |
  'success'           |
  'informational'     |
  'helpful'           |
  'no-hitter'         |
  'live-look'         ;

interface Props {
  text: string;
  alertType: AlertTypes;
}

export const Alert = ({ text, alertType, }: Props) => (
  <div
    className={classNames(styles.pAlert, {
      [styles[`pAlert${alertType}`]]: alertType,
    })}
    role='alert'
  >
    <div className={styles.pAlertText}>
      {text}
    </div>
  </div>
)
